import { render, staticRenderFns } from "./cutsomQueryLogicTree.vue?vue&type=template&id=2163917a&"
import script from "./cutsomQueryLogicTree.vue?vue&type=script&lang=js&"
export * from "./cutsomQueryLogicTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/query/cutsomQueryLogicTree.vue"
export default component.exports